// import { BookingsData, deleteValetBooking } from "../../../utils/apis/bookings_repository";
// import { Text } from "../Text";
// import { Button } from "../CustomButton";
// import { Divider } from "@mui/material";
// import { useEffect, useState } from "react";
// import BookingsDetailsBody from "../../ui/sheets/body/BookingDetailsBody";
// import EditBookingBody from "./body/EditBookingBody";
// import { useMutation, useQueryClient } from "@tanstack/react-query";
// import { deleteSingleBooking, deleteMultiBooking } from "../../../utils/apis/bookings_repository";
// import { showToast } from "../../../utils/toast";
// import { Dialog, DialogContent } from "../Dialog";
// import { handleOverstayPayment, handleValetCancelBooking } from "../../../utils/apis/payment_repository";
// import { Spinner } from "../Spinner";
// import ValetDetailsBody from "./body/ValetDetailsBody";
// import CreateComplimentaryValetBookingBody from "./CreateComplimentaryValetBooking";

// interface BookingsDetailsProps {
//     booking: BookingsData;
//     setSheetState: (state: boolean) => void;
// }

// const BookingsDetails = ({ booking, setSheetState: setDialogState }: BookingsDetailsProps) => {

//     // use state for changing body of booking
//     const [body, setBody] = useState("details");
//     const queryClient = useQueryClient();

//     const [singleDialog, openSingleDialog] = useState(false);
//     const [multiDialog, openMultiDialog] = useState(false);
//     const [overstayDialog, openOverstayDialog] = useState(false);
//     const [valetComplemenatryDialog, setValetComplimentaryDialog] = useState(false);

//     // create isLoading state for mutation
//     const [isSingleDeleteLoading, setIsSingleDeleteLoading] = useState<boolean>(false);
//     const [isMultiDeleteLoading, setIsMultiDeleteLoading] = useState<boolean>(false);

//     // create isLoading for overstay payment
//     const [isOverstayPaymentLoading, setIsOverstayPaymentLoading] = useState<boolean>(false);
//     const [isOverstayPaymentCharged, setIsOverstayPaymentCharged] = useState<boolean>(false);

//     const updatedBooking: Partial<BookingsData> = {
//         bookingType: booking.bookingType,
//         startTime: booking.startTime,
//         originalBooking: booking.originalBooking,
//         endTime: booking.endTime,
//         status: booking.status,
//         plate: booking.plate,
//         multiID: booking.multiID
//     }

//     const handleValetComplimentarySheetClose = (val: boolean) => {
//         setValetComplimentaryDialog(val);
//         setDialogState(val);
//     }

//     const handleOverstayCharge = async () => {
//         openOverstayDialog(true);
//     }

//     const handleConfirmOverstayCharge = async () => {
//         setIsOverstayPaymentLoading(true);
//         openOverstayDialog(false);
//         const success = await handleOverstayPayment(booking);
//         if (success) {
//             setIsOverstayPaymentCharged(true);
//             setIsOverstayPaymentLoading(false);
//             setTimeout(() => {
//                 setIsOverstayPaymentCharged(false);
//             }, 60000);
//         }
//     }
//     const handleEditClick = () => {
//         setBody("edit");
//     }

//     const handleCancelClick = () => {
//         setBody("details");
//     }


//     const handleValetDetailsClick = () => {
//         setBody("valet");
//     };

//     const deleteSingleBookingMutation = useMutation({
//         mutationFn: deleteSingleBooking,
//         onSuccess: () => {
//             queryClient.invalidateQueries({ queryKey: ['bookings'] }).then(() => {
//                 setIsSingleDeleteLoading(false);
//                 setDialogState(false);
//             });
//         },
//     })

//     const deleteMultiBookingMutation = useMutation({
//         mutationFn: deleteMultiBooking,
//         onSuccess: () => {
//             queryClient.invalidateQueries({ queryKey: ['bookings'] }).then(() => {
//                 setIsMultiDeleteLoading(false);
//                 setDialogState(false);
//             });
//         },
//     })

//     const handleSingleDeleteClick = async () => {
//         setIsSingleDeleteLoading(true);
//         openSingleDialog(false);

//         if(booking.bookingType === "Guest" && booking.tenant === "VALET" ){
//             await handleValetCancelBooking(booking.bookingId);
//             setIsSingleDeleteLoading(false);
//             queryClient.invalidateQueries({ queryKey: ['bookings'] });
//             setDialogState(false);
//         }else{
//             deleteSingleBookingMutation.mutate(booking.bookingId);
//         }
//     }

//     const handleSheetClose = (val: boolean) => {
//         setBody("details");
//         setDialogState(val);
//     }

//     const handleMultiDeleteClick = async () => {
//         setIsMultiDeleteLoading(true);
//         openMultiDialog(false);
//         if (booking.multiID) {
//             deleteMultiBookingMutation.mutate(booking.multiID);
//         } else {
//             showToast('Multi ID cannot be determined', { type: 'error' })
//         }
//     }

//     return (
//         <div className="flex flex-col h-screen overflow-hidden items-between mt-12 mx-6">
//             <div className="flex flex-row items-center justify-between">
//                 <Text as="h2"> {body === "details"
//                         ? "Booking Details"
//                         : body === "edit"
//                         ? "Edit Booking"
//                         : "Valet Details"}</Text>
//                 <div className="flex flex-row space-x-4 items-center">
//                     {/* {body === "details" ? <Button variant={"secondary"} onClick={handl
//                     eEditClick} className="w-38 border-primary text-primaryText">Edit Booking</Button> : <Button variant={"secondary"} onClick={handleCancelClick} className="w-38 border-primary text-primaryText">View Details</Button>} */}
//                     {body === "details" ? (
//                         <>
//                             <Button variant={"secondary"} onClick={handleEditClick} className="w-38 border-primary text-primaryText">Edit Booking</Button>
//                             {booking.tenant === "VALET" && booking.paymentId !== 'complimentary' && (
//                                 <Button disabled={isOverstayPaymentCharged} variant={"secondary"} onClick={handleOverstayCharge} className="w-38 border-primary bg-primary text-white">
//                                     {isOverstayPaymentLoading ? <div className="flex items-center">
//                                         <Spinner fill={"white"} />
//                                     </div> : "Pay Overstay Fee"}
//                                 </Button>
//                             )}

//                         </>
//                     ) : (
//                         <Button variant={"secondary"} onClick={handleCancelClick} className="w-38 border-primary text-primaryText">View Details</Button>
//                     )}
//                     <Dialog open={singleDialog} onOpenChange={(val) => openSingleDialog(val)}>
//                         <Button onClick={() => openSingleDialog(true)} isLoading={isSingleDeleteLoading} className="bg-delete w-38">Delete Booking</Button>
//                         <DialogContent>
//                             <Text as="h3" className="text-center">Delete Booking</Text>
//                             <Text as="span" className="text-center">Are you sure you want to delete this booking? Deleting this booking will result in the user not being able to enter the carpark</Text>
//                             <div className="flex flex-row justify-center space-x-4 mt-6">
//                                 <Button onClick={() => openSingleDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
//                                 <Button onClick={handleSingleDeleteClick} className="w-44 bg-delete text-white">Delete</Button>
//                             </div>
//                         </DialogContent>
//                     </Dialog>
//                     <Dialog open={multiDialog} onOpenChange={(val) => openMultiDialog(val)}>
//                         {booking.bookingType === "Single" ? null : booking.bookingType === "Guest" ? null : <Button isLoading={isMultiDeleteLoading} onClick={() => openMultiDialog(true)} className="bg-delete w-38 text-white">Delete Booking Series</Button>}
//                         <DialogContent>
//                             <Text as="h3" className="text-center">Delete Booking Series</Text>
//                             <Text as="span" className="text-center">Are you sure you want to delete this booking? Deleting this booking will result in the entire booking series being cancelled</Text>
//                             <div className="flex flex-row justify-center space-x-4 mt-6">
//                                 <Button onClick={() => openMultiDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
//                                 <Button onClick={handleMultiDeleteClick} className="w-44 bg-delete text-white">Delete</Button>
//                             </div>
//                         </DialogContent>
//                     </Dialog>
//                     <Dialog open={overstayDialog} onOpenChange={(val) => openOverstayDialog(val)}>
//                         <DialogContent>
//                             <Text as="h3" className="text-center">Overstay Charge</Text>
//                             {isOverstayPaymentCharged ? (
//                                 <Text as="span" className="text-center">You have already charged for overstaying. Do you want to charge again?</Text>
//                             ) : (
//                                 <Text as="span" className="text-center">Do you want to charge for overstaying?</Text>
//                             )}
//                             <div className="flex flex-row justify-center space-x-4 mt-6">
//                                 <Button onClick={() => openOverstayDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
//                                 <Button onClick={handleConfirmOverstayCharge} className="w-44 bg-primary text-white">Charge</Button>
//                             </div>
//                         </DialogContent>
//                     </Dialog>
//                 </div>
//             </div>
//             <div className="pt-10">
//                 <Divider className="bg-secondaryText" />
//             </div>
//             {body === "details" ? (
//                 <BookingsDetailsBody booking={booking} />
//             ) :
//                 (<EditBookingBody setSheetState={(val) => handleSheetClose(val)} bookingId={booking.bookingId} booking={updatedBooking} />
//         )}</div>
//     );
// }

// export default BookingsDetails;
import { refreshBookings } from "../../../utils/apis/refreshBookings";
import { BookingsData } from "../../../utils/apis/bookings_repository";
import { Text } from "../Text";
import { Button } from "../CustomButton";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { useState } from "react";
import BookingsDetailsBody from "../../ui/sheets/body/BookingDetailsBody";
import EditBookingBody from "./body/EditBookingBody";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteSingleBooking, deleteMultiBooking, listedAsBooking } from "../../../utils/apis/bookings_repository";
import { showToast } from "../../../utils/toast";
import { cancelSeries, cancelSeriesDay, madeByService, seriesNeedsService } from "../../../utils/apis/series_days";
import { Dialog, DialogContent } from "../Dialog";
import { handleOverstayPayment, handleValetCancelBooking } from "../../../utils/apis/payment_repository";
import { Spinner } from "../Spinner";
import CreateComplimentaryValetBookingBody from "./CreateComplimentaryValetBooking";

interface BookingsDetailsProps {
    booking: BookingsData;
    setSheetState: (state: boolean) => void;
}

const BookingsDetails = ({ booking, setSheetState: setDialogState }: BookingsDetailsProps) => {

    // use state for changing body of booking
    const [body, setBody] = useState("details");
    const queryClient = useQueryClient();

    const [singleDialog, openSingleDialog] = useState(false);
    const [multiDialog, openMultiDialog] = useState(false);
    const [overstayDialog, openOverstayDialog] = useState(false);

    // create isLoading state for mutation
    const [isSingleDeleteLoading, setIsSingleDeleteLoading] = useState<boolean>(false);
    const [isMultiDeleteLoading, setIsMultiDeleteLoading] = useState<boolean>(false);

    // A series the service made shows its days as single bookings; once the company has switched over it can
    // still be cancelled as a whole, through the service.
    const { data: seriesViaService = false } = useQuery({
        queryKey: ['seriesViaService', booking.multiID, booking.userId],
        queryFn: () => seriesNeedsService(booking),
        enabled: madeByService(booking),
    });

    // create isLoading for overstay payment
    const [isOverstayPaymentLoading, setIsOverstayPaymentLoading] = useState<boolean>(false);
    const [isOverstayPaymentCharged, setIsOverstayPaymentCharged] = useState<boolean>(false);

    const updatedBooking: Partial<BookingsData> = {
        // Who and what the booking is: a series day at a switched-over company changes through the booking service.
        bookingId: booking.bookingId,
        userId: booking.userId,
        tenant: booking.tenant,
        timeType: booking.timeType,
        bookingType: booking.bookingType,
        parkingSpaceType: booking.parkingSpaceType,
        startTime: booking.startTime,
        originalBooking: booking.originalBooking,
        endTime: booking.endTime,
        status: booking.status,
        plate: booking.plate,
        multiID: booking.multiID,
        name: booking.name,
        email: booking.email,
        phone: booking.phone,
        venue: booking.venue
    }

    const handleValetComplimentarySheetClose = (val: boolean) => {
        // setValetComplimentaryDialog(val);
        setDialogState(val);
    }

    const handleOverstayCharge = async () => {
        openOverstayDialog(true);
    }

    const handleConfirmOverstayCharge = async () => {
        setIsOverstayPaymentLoading(true);
        openOverstayDialog(false);
        const success = await handleOverstayPayment(booking);
        if (success) {
            setIsOverstayPaymentCharged(true);
            setIsOverstayPaymentLoading(false);
            setTimeout(() => {
                setIsOverstayPaymentCharged(false);
            }, 60000);
        }
    }
    const handleEditClick = () => {
        setBody("edit");
    }

    const handleCancelClick = () => {
        setBody("details");
    }
    //     const handleValetDetailsClick = () => {
    //     setBody("valet");
    // };
    const deleteSingleBookingMutation = useMutation({
        mutationFn: deleteSingleBooking,
        onSuccess: () => {
            refreshBookings(queryClient).then(() => {
                setIsSingleDeleteLoading(false);
                setDialogState(false);
            });
        },
    })

    const deleteMultiBookingMutation = useMutation({
        mutationFn: deleteMultiBooking,
        onSuccess: () => {
            refreshBookings(queryClient).then(() => {
                setIsMultiDeleteLoading(false);
                setDialogState(false);
            });
        },
    })

    // Series days at a switched-over company are cancelled through the booking service.
    const serviceCancelMutation = useMutation({
        mutationFn: (cancel: () => Promise<boolean>) => cancel(),
        onSuccess: (cancelled) => {
            setIsSingleDeleteLoading(false);
            setIsMultiDeleteLoading(false);
            if (cancelled) refreshBookings(queryClient).then(() => setDialogState(false));
        },
        onError: () => {
            showToast("We couldn't cancel this booking just now. Please try again.", { type: "error" });
            setIsSingleDeleteLoading(false);
            setIsMultiDeleteLoading(false);
        },
    })

    const handleSingleDeleteClick = async () => {
        setIsSingleDeleteLoading(true);
        openSingleDialog(false);

        if(booking.bookingType === "Guest" && booking.tenant === "VALET" ){
            await handleValetCancelBooking(booking.bookingId);
            setIsSingleDeleteLoading(false);
            refreshBookings(queryClient);
            setDialogState(false);
        }else if (booking.multiID) {
            // The rules refuse a direct delete of a series day once the company has switched over.
            let viaService = false;
            try {
                viaService = await seriesNeedsService(booking);
            } catch (error) {
                showToast("We couldn't reach the booking service just now. Please try again.", { type: "error" });
                setIsSingleDeleteLoading(false);
                return;
            }
            if (viaService) serviceCancelMutation.mutate(() => cancelSeriesDay(booking));
            else deleteSingleBookingMutation.mutate(booking.bookingId);
        }else{
            deleteSingleBookingMutation.mutate(booking.bookingId);
        }
    }

    const handleSheetClose = (val: boolean) => {
        setBody("details");
        setDialogState(val);
    }

    const handleMultiDeleteClick = async () => {
        setIsMultiDeleteLoading(true);
        openMultiDialog(false);
        if (booking.multiID && madeByService(booking) && seriesViaService) {
            serviceCancelMutation.mutate(() => cancelSeries(booking));
        } else if (booking.multiID) {
            deleteMultiBookingMutation.mutate(booking.multiID);
        } else {
            showToast('Multi ID cannot be determined', { type: 'error' })
        }
    }

    // The series' other days as the bookings list has them now, so the details show what's left of it.
    const seriesDays = booking.multiID ? (queryClient.getQueryData<BookingsData[]>(['bookings']) ?? [])
        .filter((day) => day.multiID === booking.multiID && listedAsBooking(day) && !["Rejected", "Cancelled", "Deleted"].includes(day.status)) : undefined;
    const seriesDeletable = !((booking.bookingType === "Single" && !(madeByService(booking) && seriesViaService)) || booking.bookingType === "Guest");

    return (
        // The shared Sheet doesn't size its body, so this fills the panel (less its padding) and pins the footer, as Create Booking does.
        <div className="flex h-[calc(100dvh-3.5rem)] flex-col text-left">
            <div className="pt-10">
                {body === "edit" && (
                    <button type="button" onClick={handleCancelClick} className="mb-2 inline-flex items-center gap-1 text-sm font-semibold text-primary">
                        <ArrowBack aria-hidden sx={{ fontSize: 18 }} />
                        Back to details
                    </button>
                )}
                <Text as="h2">{body === "details" ? "Booking details" : "Edit booking"}</Text>
            </div>

            {body === "details" ? (
                <>
                    <div className="flex-1 overflow-y-auto pr-1">
                        <BookingsDetailsBody booking={booking} seriesDays={seriesDays} />
                    </div>
                    {/* Actions, as at the foot of the other booking sheets */}
                    <div className="flex flex-wrap gap-3 border-t border-app-border pt-4 pb-6">
                        <Button variant={"secondary"} onClick={() => openSingleDialog(true)} isLoading={isSingleDeleteLoading} className="flex-1 border border-delete text-delete">Delete booking</Button>
                        {seriesDeletable && <Button variant={"secondary"} isLoading={isMultiDeleteLoading} onClick={() => openMultiDialog(true)} className="flex-1 border border-delete text-delete">Delete booking series</Button>}
                        {booking.tenant === "VALET" && booking.paymentId !== 'complimentary' && (
                            <Button disabled={isOverstayPaymentCharged} variant={"secondary"} onClick={handleOverstayCharge} className="flex-1 border border-primary text-primaryText">
                                {isOverstayPaymentLoading ? <div className="flex items-center">
                                    <Spinner />
                                </div> : "Pay overstay fee"}
                            </Button>
                        )}
                        <Button variant={"default"} onClick={handleEditClick} className="flex-[2] text-white">Edit booking</Button>
                    </div>
                </>
            ) : booking.paymentId === "complimentary" ? (
                <div className="min-h-0 flex-1 overflow-y-auto">
                    <CreateComplimentaryValetBookingBody setDialogState={handleValetComplimentarySheetClose} editData={booking}/>
                </div>
            ) : <EditBookingBody setSheetState={(val) => handleSheetClose(val)} bookingId={booking.bookingId} booking={updatedBooking} />}

            <Dialog open={singleDialog} onOpenChange={(val) => openSingleDialog(val)}>
                <DialogContent>
                    <Text as="h3" className="text-center">Delete Booking</Text>
                    <Text as="span" className="text-center">Are you sure you want to delete this booking? Deleting this booking will result in the user not being able to enter the carpark</Text>
                    <div className="flex flex-row justify-center space-x-4 mt-6">
                        <Button onClick={() => openSingleDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
                        <Button onClick={handleSingleDeleteClick} className="w-44 bg-delete text-white">Delete</Button>
                    </div>
                </DialogContent>
            </Dialog>
            <Dialog open={multiDialog} onOpenChange={(val) => openMultiDialog(val)}>
                <DialogContent>
                    <Text as="h3" className="text-center">Delete Booking Series</Text>
                    <Text as="span" className="text-center">Are you sure you want to delete this booking? Deleting this booking will result in the entire booking series being cancelled</Text>
                    <div className="flex flex-row justify-center space-x-4 mt-6">
                        <Button onClick={() => openMultiDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
                        <Button onClick={handleMultiDeleteClick} className="w-44 bg-delete text-white">Delete</Button>
                    </div>
                </DialogContent>
            </Dialog>
            <Dialog open={overstayDialog} onOpenChange={(val) => openOverstayDialog(val)}>
                <DialogContent>
                    <Text as="h3" className="text-center">Overstay Charge</Text>
                    {isOverstayPaymentCharged ? (
                        <Text as="span" className="text-center">You have already charged for overstaying. Do you want to charge again?</Text>
                    ) : (
                        <Text as="span" className="text-center">Do you want to charge for overstaying?</Text>
                    )}
                    <div className="flex flex-row justify-center space-x-4 mt-6">
                        <Button onClick={() => openOverstayDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
                        <Button onClick={handleConfirmOverstayCharge} className="w-44 bg-primary text-white">Charge</Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default BookingsDetails;
// import { BookingsData, deleteValetBooking } from "../../../utils/apis/bookings_repository";
// import { Text } from "../Text";
// import { Button } from "../CustomButton";
// import { Divider } from "@mui/material";
// import { useEffect, useState } from "react";
// import BookingsDetailsBody from "../../ui/sheets/body/BookingDetailsBody";
// import EditBookingBody from "./body/EditBookingBody";
// import { useMutation, useQueryClient } from "@tanstack/react-query";
// import { deleteSingleBooking, deleteMultiBooking } from "../../../utils/apis/bookings_repository";
// import { showToast } from "../../../utils/toast";
// import { Dialog, DialogContent } from "../Dialog";
// import { handleOverstayPayment, handleValetCancelBooking } from "../../../utils/apis/payment_repository";
// import { Spinner } from "../Spinner";
// import CreateComplimentaryValetBookingBody from "./CreateComplimentaryValetBooking";
// import ValetDetailsBody from "./body/ValetDetailsBody";

// interface BookingsDetailsProps {
//     booking: BookingsData;
//     setSheetState: (state: boolean) => void;
// }

// const BookingsDetails = ({ booking, setSheetState: setDialogState }: BookingsDetailsProps) => {

//     // use state for changing body of booking
//     const [body, setBody] = useState("details");
//     const queryClient = useQueryClient();

//     const [singleDialog, openSingleDialog] = useState(false);
//     const [multiDialog, openMultiDialog] = useState(false);
//     const [overstayDialog, openOverstayDialog] = useState(false);
//     const [valetComplemenatryDialog, setValetComplimentaryDialog] = useState(false);

//     // create isLoading state for mutation
//     const [isSingleDeleteLoading, setIsSingleDeleteLoading] = useState<boolean>(false);
//     const [isMultiDeleteLoading, setIsMultiDeleteLoading] = useState<boolean>(false);

//     // create isLoading for overstay payment
//     const [isOverstayPaymentLoading, setIsOverstayPaymentLoading] = useState<boolean>(false);
//     const [isOverstayPaymentCharged, setIsOverstayPaymentCharged] = useState<boolean>(false);

//     const updatedBooking: Partial<BookingsData> = {
//         bookingType: booking.bookingType,
//         startTime: booking.startTime,
//         originalBooking: booking.originalBooking,
//         endTime: booking.endTime,
//         status: booking.status,
//         plate: booking.plate,
//         multiID: booking.multiID
//     }

//     const handleValetComplimentarySheetClose = (val: boolean) => {
//         setValetComplimentaryDialog(val);
//         setDialogState(val);
//     }

//     const handleOverstayCharge = async () => {
//         openOverstayDialog(true);
//     }

//     const handleConfirmOverstayCharge = async () => {
//         setIsOverstayPaymentLoading(true);
//         openOverstayDialog(false);
//         const success = await handleOverstayPayment(booking);
//         if (success) {
//             setIsOverstayPaymentCharged(true);
//             setIsOverstayPaymentLoading(false);
//             setTimeout(() => {
//                 setIsOverstayPaymentCharged(false);
//             }, 60000);
//         }
//     }
//     const handleEditClick = () => {
//         setBody("edit");
//     }

//     const handleCancelClick = () => {
//         setBody("details");
//     }


//     const handleValetDetailsClick = () => {
//         setBody("valet");
//     };

//     const deleteSingleBookingMutation = useMutation({
//         mutationFn: deleteSingleBooking,
//         onSuccess: () => {
//             queryClient.invalidateQueries({ queryKey: ['bookings'] }).then(() => {
//                 setIsSingleDeleteLoading(false);
//                 setDialogState(false);
//             });
//         },
//     })

//     const deleteMultiBookingMutation = useMutation({
//         mutationFn: deleteMultiBooking,
//         onSuccess: () => {
//             queryClient.invalidateQueries({ queryKey: ['bookings'] }).then(() => {
//                 setIsMultiDeleteLoading(false);
//                 setDialogState(false);
//             });
//         },
//     })

//     const handleSingleDeleteClick = async () => {
//         setIsSingleDeleteLoading(true);
//         openSingleDialog(false);

//         if(booking.bookingType === "Guest" && booking.tenant === "VALET" ){
//             await handleValetCancelBooking(booking.bookingId);
//             setIsSingleDeleteLoading(false);
//             queryClient.invalidateQueries({ queryKey: ['bookings'] });
//             setDialogState(false);
//         }else{
//             deleteSingleBookingMutation.mutate(booking.bookingId);
//         }
//     }

//     const handleSheetClose = (val: boolean) => {
//         setBody("details");
//         setDialogState(val);
//     }

//     const handleMultiDeleteClick = async () => {
//         setIsMultiDeleteLoading(true);
//         openMultiDialog(false);
//         if (booking.multiID) {
//             deleteMultiBookingMutation.mutate(booking.multiID);
//         } else {
//             showToast('Multi ID cannot be determined', { type: 'error' })
//         }
//     }

//     return (
//         <div className="flex flex-col h-screen overflow-hidden items-between mt-12 mx-6">
//             <div className="flex flex-row items-center justify-between">
//                 <Text as="h2"> {body === "details"
//                         ? "Booking Details"
//                         : body === "edit"
//                         ? "Edit Booking"
//                         : "Valet Details"}</Text>
//                 <div className="flex flex-row space-x-4 items-center">
//                     {/* {body === "details" ? <Button variant={"secondary"} onClick={handl
//                     eEditClick} className="w-38 border-primary text-primaryText">Edit Booking</Button> : <Button variant={"secondary"} onClick={handleCancelClick} className="w-38 border-primary text-primaryText">View Details</Button>} */}
//                     {body === "details" ? (
//                         <>
//                             <Button variant={"secondary"} onClick={handleEditClick} className="w-38 border-primary text-primaryText">Edit Booking</Button>
//                             {booking.tenant === "VALET" && booking.paymentId !== 'complimentary' && (
//                                 <Button disabled={isOverstayPaymentCharged} variant={"secondary"} onClick={handleOverstayCharge} className="w-38 border-primary bg-primary text-white">
//                                     {isOverstayPaymentLoading ? <div className="flex items-center">
//                                         <Spinner fill={"white"} />
//                                     </div> : "Pay Overstay Fee"}
//                                 </Button>
//                             )}

//                         </>
//                     ) : (
//                         <Button variant={"secondary"} onClick={handleCancelClick} className="w-38 border-primary text-primaryText">View Details</Button>
//                     )}
//                     <Dialog open={singleDialog} onOpenChange={(val) => openSingleDialog(val)}>
//                         <Button onClick={() => openSingleDialog(true)} isLoading={isSingleDeleteLoading} className="bg-delete w-38">Delete Booking</Button>
//                         <DialogContent>
//                             <Text as="h3" className="text-center">Delete Booking</Text>
//                             <Text as="span" className="text-center">Are you sure you want to delete this booking? Deleting this booking will result in the user not being able to enter the carpark</Text>
//                             <div className="flex flex-row justify-center space-x-4 mt-6">
//                                 <Button onClick={() => openSingleDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
//                                 <Button onClick={handleSingleDeleteClick} className="w-44 bg-delete text-white">Delete</Button>
//                             </div>
//                         </DialogContent>
//                     </Dialog>
//                     <Dialog open={multiDialog} onOpenChange={(val) => openMultiDialog(val)}>
//                         {booking.bookingType === "Single" ? null : booking.bookingType === "Guest" ? null : <Button isLoading={isMultiDeleteLoading} onClick={() => openMultiDialog(true)} className="bg-delete w-38 text-white">Delete Booking Series</Button>}
//                         <DialogContent>
//                             <Text as="h3" className="text-center">Delete Booking Series</Text>
//                             <Text as="span" className="text-center">Are you sure you want to delete this booking? Deleting this booking will result in the entire booking series being cancelled</Text>
//                             <div className="flex flex-row justify-center space-x-4 mt-6">
//                                 <Button onClick={() => openMultiDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
//                                 <Button onClick={handleMultiDeleteClick} className="w-44 bg-delete text-white">Delete</Button>
//                             </div>
//                         </DialogContent>
//                     </Dialog>
//                     <Dialog open={overstayDialog} onOpenChange={(val) => openOverstayDialog(val)}>
//                         <DialogContent>
//                             <Text as="h3" className="text-center">Overstay Charge</Text>
//                             {isOverstayPaymentCharged ? (
//                                 <Text as="span" className="text-center">You have already charged for overstaying. Do you want to charge again?</Text>
//                             ) : (
//                                 <Text as="span" className="text-center">Do you want to charge for overstaying?</Text>
//                             )}
//                             <div className="flex flex-row justify-center space-x-4 mt-6">
//                                 <Button onClick={() => openOverstayDialog(false)} variant="secondary" className="w-44 border-primary text-primaryText">Cancel</Button>
//                                 <Button onClick={handleConfirmOverstayCharge} className="w-44 bg-primary text-white">Charge</Button>
//                             </div>
//                         </DialogContent>
//                     </Dialog>
//                 </div>
//             </div>
//             <div className="pt-10">
//                 <Divider className="bg-secondaryText" />
//             </div>
//             {body === "details" ?
//                 <BookingsDetailsBody booking={booking} /> : booking.paymentId === "complimentary" ? <CreateComplimentaryValetBookingBody setDialogState={handleValetComplimentarySheetClose} editData={booking}/>
//              :
//                 (<EditBookingBody setSheetState={(val) => handleSheetClose(val)} bookingId={booking.bookingId} booking={updatedBooking} />
//         )}</div>
//     );
// }

// export default BookingsDetails;
